import React, { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import AlertBottomMessage from 'components/AlertBottomMessage';

import { HeaderLoggedIn } from 'scenes/Header';

import { toggleTutorialModal } from 'store/modules/modals';
import { getFullStatAction } from 'store/modules/analitics';
import videoSvg from 'images/video-solid.svg';

import DoughnutChart from 'components/DoughnutChart';
import LineChartAnalitics from 'components/LineChartAnalitics';
import TopsAnalitics from './TopsAnalitics';

const DashboardNavigation = ({ id, toggle }) => {
  return (
    <div className="nav-tabs">
      <div className="nav-tabs__inner">
        <NavLink to={`/domain/page/${id}/content`} className="nav-tabs__link">
          Content
        </NavLink>
        <NavLink to={`/domain/page/${id}/styles`} className="nav-tabs__link">
          Styles
        </NavLink>
        <NavLink to={`/domain/page/${id}/analytics`} className="nav-tabs__link">
          Analytics
        </NavLink>
        <div
          className="std-text blue pointer p-l-150 tutorial-help__link"
          onClick={toggle}>
          <span className="icon-outline">
            <img src={videoSvg} alt="acc" />
          </span>
          <span className="link-text">Watch tutorial</span>
        </div>
      </div>
    </div>
  );
};

class Analytics extends Component {
  state = {
    openModal: false,
  };

  componentDidMount() {
    const { getFullStatAction, match } = this.props;
    const id = match.params.id;
    getFullStatAction(id);
  }

  toggleModal = () => {
    const { toggleTutorialModal } = this.props;
    toggleTutorialModal();
  };

  render() {
    const { account } = this.props;
    const {
      daily_view_stat,
      monthly_view_stat,
      browsers,
      operation_systems,
      cities_top,
      countries_top,
      referrers_top,
    } = this.props.full_stat;
    const { details } = this.props;
    const dataTops = [
      {
        title: 'Top cities',
        list: cities_top,
      },
      {
        title: 'Top countries',
        list: countries_top,
      },
      {
        title: 'Top referrers',
        list: referrers_top,
      },
    ];
    return (
      <Fragment>
        <AlertBottomMessage analytics />
        <DashboardNavigation id={account.id} toggle={this.toggleModal} />
        <div className="main__content">
          <div className="b-row m-b-40">
            <div className="b-col-6 b-col-sm-12 analytic-left">
              <h2 className="h2-title">Daily stats: page views</h2>
              <div className="text text-300">
                Daily statistics of page viewing
              </div>
              <div className="separator-line" />
              <div className="graphic-itm">
                <div className="graphic-itm__inner">
                  <LineChartAnalitics
                    labels={daily_view_stat.labels}
                    data={daily_view_stat.data}
                    maxValue={150}
                    interval={50}
                  />
                </div>
              </div>
            </div>
            <div className="b-col-6 b-col-sm-12 analytic-right">
              <h2 className="h2-title">Monthly stats: page views</h2>
              <div className="text text-300">
                Monthly statistics of page viewing
              </div>
              <div className="separator-line" />
              <div className="graphic-itm">
                <div className="graphic-itm__inner">
                  <LineChartAnalitics
                    labels={monthly_view_stat.labels}
                    data={monthly_view_stat.data}
                    maxValue={600}
                    interval={200}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="b-row m-b-40">
            <div className="b-col-6 b-col-sm-12 analytic-left">
              <h2 className="h2-title">Browser</h2>
              <div className="separator-line" />
              <div className="graphic-itm bg">
                <div className="graphic-itm__inner">
                  <DoughnutChart
                    labels={browsers.labels}
                    data={browsers.data}
                    backgroundColor={[
                      '#abacac',
                      '#6e6e6e',
                      '#434343',
                      '#1bccfc',
                      '#15a1c6',
                      '#000',
                    ]}
                  />
                </div>
              </div>
            </div>
            <div className="b-col-6 b-col-sm-12 analytic-right">
              <h2 className="h2-title">Operating system</h2>
              <div className="separator-line" />
              <div className="graphic-itm bg">
                <div className="graphic-itm__inner">
                  <DoughnutChart
                    labels={operation_systems.labels}
                    data={operation_systems.data}
                    backgroundColor={[
                      '#1bccfc',
                      '#18afc7',
                      '#49db68',
                      '#8dee40',
                      '#048dfa',
                      '#0466b2',
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="b-row m-b-40">
            <TopsAnalitics data={dataTops} />
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateProps(state) {
  return {
    full_stat: state.full_stat.full_stat,
    account: state.content.account,
    details: state.details.user,
  };
}

const mapDispatchToProps = {
  toggleTutorialModal,
  getFullStatAction,
};
export default connect(
  mapStateProps,
  mapDispatchToProps,
)(Analytics);



// WEBPACK FOOTER //
// ./src/scenes/Analytics/Analytics.js